"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Datepicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
require("../styles/datepicker.css");
require("@oneloop/theme/styles/globals.css");
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _input = require("@oneloop/input");
var _locale = require("date-fns/locale");
var _excluded = ["locale"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var CustomInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var value = _ref.value,
    onClick = _ref.onClick;
  var inputRef = (0, _react.useRef)(ref);
  var handleClick = function handleClick() {
    return inputRef.current.click();
  };
  return /*#__PURE__*/_react["default"].createElement(_input.Input, {
    style: {
      paddingLeft: '34px'
    },
    ref: inputRef,
    onClick: onClick,
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
      icon: 'icon-calendario',
      fontSize: "16px",
      onClick: handleClick,
      style: {
        cursor: 'pointer'
      }
    }),
    value: value
  });
});
CustomInput.displayName = 'CustomInput';
var CustomHeader = function CustomHeader(_ref2) {
  var date = _ref2.date,
    decreaseMonth = _ref2.decreaseMonth,
    increaseMonth = _ref2.increaseMonth,
    prevMonthButtonDisabled = _ref2.prevMonthButtonDisabled,
    nextMonthButtonDisabled = _ref2.nextMonthButtonDisabled,
    locale = _ref2.locale;
  var formatDate = function formatDate(date, locale) {
    var month = date.toLocaleString(locale.code, {
      month: 'long'
    }).replace(/^./, function (match) {
      return match.toUpperCase();
    });
    var year = date.toLocaleString(locale.code, {
      year: 'numeric'
    });
    return "".concat(month, " ").concat(year);
  };
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "customHeader"
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "button",
    className: "customHeaderButton",
    onClick: decreaseMonth,
    disabled: prevMonthButtonDisabled
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: "icon-atras",
    fontSize: "16px",
    color: "#2E393F"
  })), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "customHeaderDate"
  }, formatDate(date, locale)), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "button",
    className: "customHeaderButton",
    onClick: increaseMonth,
    disabled: nextMonthButtonDisabled
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: "icon-siguiente",
    fontSize: "16px",
    color: "#2E393F"
  })));
};
var Datepicker = exports.Datepicker = function Datepicker(props) {
  var locale = props.locale,
    rest = _objectWithoutProperties(props, _excluded);
  var targetLocale = locale !== null && locale !== void 0 ? locale : _locale.enUS;
  return /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], _extends({
    className: "red-border",
    customInput: /*#__PURE__*/_react["default"].createElement(CustomInput, null),
    renderCustomHeader: function renderCustomHeader(headerProps) {
      return /*#__PURE__*/_react["default"].createElement(CustomHeader, _extends({}, headerProps, {
        locale: targetLocale
      }));
    },
    locale: targetLocale
  }, rest));
};